import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MarketBuildingService } from '../services/market-building.service';
import { BuildingScoresService } from '../services/building-scores.service';
import { Router } from '@angular/router';
import { MouseEvent, AgmMap, LatLngBounds } from '@agm/core';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { IMyDpOptions } from 'mydatepicker';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BuildingList } from '../entity/UserDetail.entity';
import { environment } from '../../environments/environment';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { PortalType } from '../core/portal-types';
import { FilterPreset } from '../core/models/filter-preset';
import { FilterService } from '../services/filter.service';
import { BuildingRatingsFilter } from '../core/models/building-ratings-filter';
import { ListRatingFiltersComponent } from '../shared/list-rating-filters/list-rating-filters.component';
import { Paths } from '../constants';

declare var google: any;
declare var $: any;

const defaultMaxValue = 'No Max';
const defaultMinValue = 'No Min';

@Component({
	selector: 'app-office-market-building',
	templateUrl: './office-market-building.component.html',
	styleUrls: ['./office-market-building.component.css']
})
export class OfficeMarketBuildingComponent implements OnInit {

	IconUrl = environment.BaseURI_Icon_MarketBuilding;

	@ViewChild('fromDate') inputFromDate: ElementRef;
	@ViewChild('toDate') inputToDate: ElementRef;

	@ViewChild(ListRatingFiltersComponent) listRatingFiltersComponent!: ListRatingFiltersComponent;

	private selectedScoreWeightSubscription: Subscription;

	public portalType: PortalType = PortalType.Market;
	public paths: any = Paths;

	public buildingFilter: BuildingRatingsFilter = {
		//Base Options
		buildingClasses: [],
		cities: [],
		dateEnd: null,
		dateStart: null,
		leaseTypes: [],
		ratingToRentRatioCurrent: {
			minimum: null,
			maximum: null
		},
		searchTerm: null,
		submarkets: [],
		districts: [],
		postalCodes: [],
		scoreWeightId: "",

		//Building Options
		buildingTenancies: [{ label: "Office Leased", value: "Office Leased" }],
		buildingStatuses: [],
		competitiveSets: [],
		askingRent: {
			minimum: null,
			maximum: null
		},
		percentLeased: [0, 100],
		directAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		subleaseAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		totalVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		directVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		subleaseVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		maxContiguousSquareFootage: {
			minimum: null,
			maximum: null
		},
		// Removed on 7/10/24
		minimumAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		// Removed on 7/10/24
		occupiedSquareFootage: {
			minimum: null,
			maximum: null
		},
		availableSquareFootage: [0, 400000],
		subclasses: [],
		propertyTypes: [],
		buildingRenovations: [],
		yearOfRenovation: {
			minimum: null,
			maximum: null
		},
		mixedUses: [],
		singleTenants: [],
		parking: [],
		numberOfFloors: {
			minimum: null,
			maximum: null
		},
		propertySize: {
			minimum: null,
			maximum: null
		},
		parkingRatio: {
			minimum: null,
			maximum: null
		},
		walkScore: [0, 100],
		proximityToLightRail: {
			minimum: null,
			maximum: null
		},

		//Rating Options
		total: {
			rating: [0, 105],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		constructionQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		askingRate: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		commonAreaQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		onSiteAmenities: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		sizeStories: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		ageBonus: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProminence: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		relevanceToConsumer: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationConvenience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProximity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingVisitorExperience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuantity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
	};
	
	public submarketOptions: string[];
	public districtOptions: string[];
	public buildingClassOptions: string[];
	public leaseTypeOptions: string[];

	public buildingTenantOptions: string[];
	public buildingStatusOptions: string[];
	public competitiveSetOptions: string[];
	public subclassOptions: string[];
	public propertyTypeOptions: string[];
	public buildingRenovationOptions: string[];
	public mixedUseOptions: string[];
	public singleTenantOptions: string[];
	public parkingOptions: string[];

	public userFilterPresets: FilterPreset[] = [];
	public userFilterPreset: FilterPreset = {
		id: "",
		name: "",
		userId: null,
		filter: null,
		createdUtc: null,
		updatedUtc: null
	}
	
	uploadForm: FormGroup;
	loader: boolean = false;
  	submitted: boolean = false;	
	//@ViewChild('containerMap') containerMap: ElementRef;
	showHeaderOptions: boolean = true;
	@Input() IsRefreshMap: boolean = false;
	Buildingobj: any = {};
	totalVacantPercentage: number;
	isPageFirstTime: boolean = true;
	rightSectionColor = { 'background': '#ffffff' };
	public fromDate: Date;
	public endDate: Date;

	defultDateSelected: boolean = false;
	public quarterAndQuarterYearList: SelectItem[];

	public officeMarketBuildingListByPropertyId: any = [];
	public showAllMarketBuildingList: BuildingList[];
	IsPdfGenerate: boolean = false;
	IsCSVGenerate: boolean = false;
	public MapLoader = false;
	buildinglist: any[];
	totalSQFt: number = 0;
	totalVancentSQFt: number = 0;
	contiguousSFMin: number;
	percentvacant: number = 0;
	//loader: boolean = true;
	isMarkerSingle: boolean = false;
	selectedFromQuarter: Absorption[];
	selectedToQuarter: Absorption[];
	selectedFromQuarterstr1: string;
	selectedFromQuarterstr2: string;
	a: SelectItem[];
	//selectedFromQuarter: string='Q12019';
	//selectedToQuarter: string='Q32019';
	markers: marker[];
	@ViewChild('AgmMap') agmMap: AgmMap;
	val: number[] = [0, 672401];
	val2: number = 672401;

	minValueSF: number;
	maxValueSF: number;
	rangeSFMaxValue: number;

	fromDateRange: string;
	toDateRange: string;
	absorptionForOccupiedSF: number = null;
	propertyId: string = '';
	value: Date;
	placeholder: string = '';
	rangeParkingRatioValues: number[] = [0, 100];
	selectedValueTenancy: string = 'Office Lease';
	zoom: number = 10;
	latitude: number = 33.438031;
	longitude: number = -111.955689;
	myFromDate: string;
	myToDate: string;
	myDecimal: number;
	isCompetitiveSetFilterSelected: number = 0;
	obj = []
	defaultDate = new Date();
	setDateOnSelectPicker: boolean = false;
	FromDateString: string;
	ToDateString: string;
	myDatePickerOptions: IMyDpOptions = {
		//todayBtnTxt: 'Today',
		dateFormat: 'mm/dd/yyyy',
		ariaLabelInputField: '',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		inline: false,
		//disableUntil: { year: 2016, month: 8, day: 10 }

	};
	public carouselImageIndex: number = 0;
	public myFormFromDate: FormGroup;
	public myFormTodate: FormGroup;
	public model: any = { date: { year: 2018, month: 10, day: 9 } };
	public model2: any = { date: { year: 2018, month: 10, day: 9 } };

	myMap:any;

	// customStyles: Array<any> = [ {"elementType": "geometry", "stylers": [{"color": "#ebe3cd"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#523735"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"} ] }, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#c9b2a6"} ] }, {"featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{"color": "#dcd2be"} ] }, {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#ae9e90"} ] }, {"featureType": "landscape.natural", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#93817c"} ] }, {"featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{"color": "#a5b076"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#447530"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#fdfcf8"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#f8c967"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#e9bc62"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{"color": "#e98d58"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{"color": "#db8555"} ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#806b63"} ] }, {"featureType": "transit", "stylers": [{"visibility": "off"} ] }, {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{"color": "#8f7d77"} ] }, {"featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{"color": "#ebe3cd"} ] }, {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "water", "elementType": "geometry.fill", "stylers": [{"color": "#b9d3c2"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#92998d"} ] } ];
	customStyles: Array<any> = [{"elementType": "geometry", "stylers": [{"color": "#242f3e"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#746855"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#242f3e"} ] }, {"featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi.attraction", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.business", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#274e36"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#6b9a76"} ] }, {"featureType": "poi.place_of_worship", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.school", "stylers": [{"visibility": "off"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#38414e"} ] }, {"featureType": "road", "elementType": "geometry.stroke", "stylers": [{"color": "#212a37"} ] }, {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"color": "#9ca5b3"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#746855"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#1f2835"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#f3d19c"} ] }, {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#2f3948"} ] }, {"featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#3a65a6"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#515c6d"} ] }, {"featureType": "water", "elementType": "labels.text.stroke", "stylers": [{"color": "#17263c"} ] } ];

	defaultCenter = { lat: 33.526567, lng: -112.064364 };
	currentCenter = Object.assign({}, this.defaultCenter);

	constructor(
		public marketService: MarketBuildingService, 
		public scoreService: BuildingScoresService, 
		private filterService: FilterService, 
		private route: Router, 
		private formBuilder: FormBuilder, 
		private datePipe: DatePipe, 
		private location: Location, 
		private httpClient: HttpClient) 
	{
		this.BuildingSquareFootageMinMaxValue();
		this.onBuildinFilterChange(event,true);

		if (this.IsRefreshMap) {
			this.onBuildinFilterChange(event,true);
		}
	}

	ngOnInit() {

		this.selectedScoreWeightSubscription = this.scoreService.selectedWeight$.subscribe(value => {
			this.marketService.scoreWeight = value;
			this.buildingFilter.scoreWeightId = value.id;
		});
		this.myDecimal = 0.01;
		this.MapLoader = true;
		this.fromDate = new Date(1900, 1, 1);
		//  this.fromDate = new Date("12/15/18 00:00:00")
		//this.fromDate = new Date(year: 2018, month: 10, day: 9 )
		this.endDate = new Date();

		//console.log(new Date());
		//console.log(this.endDate);
		this.myFormFromDate = this.formBuilder.group({
			myFromDate: [{ date: { year: this.fromDate.getFullYear(), month: this.fromDate.getMonth(), day: this.fromDate.getDate() } }, Validators.required]

		});

		//console.log(this.myFormFromDate + "calling " + this.myFromDate + "FromDate Year: " + this.fromDate.getFullYear() + " Month: " + this.fromDate.getMonth() + " Date: " + this.fromDate.getDate());
		this.myFormTodate = this.formBuilder.group({
			myToDate: [{ date: { year: this.endDate.getFullYear(), month: this.endDate.getMonth() + 1, day: this.endDate.getDate() } }, Validators.required]
		});

		//this.fromDate = new Date(this.myFormFromDate.value.myFromDate.date.year, this.myFormFromDate.value.myFromDate.date.month - 1, this.myFormFromDate.value.myFromDate.date.day + 1);
		//this.endDate = new Date(this.myFormTodate.value.myToDate.date.year, this.myFormTodate.value.myToDate.date.month - 1, this.myFormTodate.value.myToDate.date.day + 1);

		//console.log(this.fromDate);
		//console.log(this.endDate);
		//this.DefaultDateSelected();
		let dateFrom = new Date("01/01/1900");
		this.FromDateString = this.datePipe.transform(dateFrom, 'MM/dd/yyyy');//"YEAR#" + this.fromDate.getUTCFullYear() + "@@MONTH#" + this.fromDate.getUTCDay() + "@@DAY#" + this.fromDate.getUTCDate();
		//this.ToDateString = this.endDate.toDateString();
			this.ToDateString = this.datePipe.transform(this.endDate, 'MM/dd/yyyy');//"YEAR#" + this.endDate.getUTCFullYear() + "@@MONTH#" + this.endDate.getUTCDay() + 1 + "@@DAY#" + this.endDate.getUTCDate();


		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;

		this.uploadForm = this.formBuilder.group({			
			image: ['', [Validators.required]],			
			propertyId: ['', [Validators.required]],
		});

		this.BuildingTenancy();
		this.SubMarket();
		this.District();
		this.BuildingClass();
		this.BuildingLeaseType();
		this.BuildingSubclass();
		this.BuildingPropertyType();
		this.BuildingRenovations();
		this.BuildingMixedUse();
		this.BuildingSingleTenant();
		this.BuildingParking();
		this.BuildingStatus();
		this.QuarterAndQuarterYear();
		this.marketService.mapTypeIdSelected = this.agmMap.mapTypeId;

		this.CompetitiveSet();
		this.getUserFilters();

		$('[data-toggle="tooltip"]').tooltip();
		this.buildinglist = [
			{ field: 'id', header: 'Id', },
			{ field: 'buildingName', header: 'Building Name' },
			{ field: 'address', header: 'Address' },
			{ field: 'buildingNRA', header: 'BuildingNRA' },
			{ field: 'ttlVacantSF', header: 'TTLVacantSF' },
		];

		$('.dataPickerInput').datepicker([]);
		$('.filterHead').click(function () {
			$(this).toggleClass("bodyShow");
			$(".filterBodySecond").slideToggle(300);
		});
		this.agmMap.mapReady.subscribe(map => {
			console.log('subscribe event called');
			this.myMap = map;
			this.geocode("Phoenix, USA").then(place => {
				//this.currentCenter = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
				this.currentCenter = { lat: 33.4483771, lng: -112.0740373 };
			 // console.log(this.currentCenter);
			})
			.catch(err => {
			 // console.log(err);
			});
		});


	}

	buildingLinkOpenInNewTab(url: string): void {
		const fullUrl = window.location.origin + url;
    	window.open(fullUrl, '_blank');
	}

	getUserFilters() {
		this.filterService.GetUserFilters(this.portalType).subscribe(
			(res: FilterPreset[]) => {
				this.userFilterPresets = res;
			},
			err => {
				console.log("Could not retrieve user filters: ", err);
			}
		);
	}

	userFilterChange(preset: FilterPreset) {
		try {
			this.buildingFilter = preset.filter;
		} catch (error) {
			console.log("Invalid filter.", error);
			alert("Invalid filter.");
		}
	}

	showFilterModal = false;

	openUserFilterModal() {
		this.showFilterModal = true;
	}

	closeUserFilterModal() {
		this.showFilterModal = false;
	}

	onDeleteUserFilter(filterId: string) {
		this.getUserFilters();
	}

	showFilterAddModal = false;

	openUserFilterAddModal() {
		this.showFilterAddModal = true;
	}

	closeUserFilterAddModal() {
		this.showFilterAddModal = false;
	}

	onAddUserFilter() {
		this.showFilterAddModal = false;
		this.getUserFilters();
	}

	ClearAll(eventData) {

		this.fromDate = new Date(1900, 1, 1);
		this.endDate = new Date();
		this.myFormFromDate = this.formBuilder.group({
			myFromDate: [{ date: { year: this.fromDate.getFullYear(), month: this.fromDate.getMonth(), day: this.fromDate.getDate() } }, Validators.required]

		});
		this.myFormTodate = this.formBuilder.group({
			myToDate: [{ date: { year: this.endDate.getFullYear(), month: this.endDate.getMonth() + 1, day: this.endDate.getDate() } }, Validators.required]
		});
		let dateFrom = new Date("01/01/1900");
		this.FromDateString = this.datePipe.transform(dateFrom, 'MM/dd/yyyy');//"YEAR#" + this.fromDate.getUTCFullYear() + "@@MONTH#" + this.fromDate.getUTCDay() + "@@DAY#" + this.fromDate.getUTCDate();
		this.ToDateString = this.datePipe.transform(this.endDate, 'MM/dd/yyyy');//"YEAR#" + this.endDate.getUTCFullYear() + "@@MONTH#" + this.endDate.getUTCDay() + 1 + "@@DAY#" + this.endDate.getUTCDate();

		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;

		this.getUserFilters();

		//Base Options
		this.buildingFilter.buildingClasses = [];
		this.buildingFilter.cities = [];
		this.buildingFilter.leaseTypes = [];
		this.buildingFilter.ratingToRentRatioCurrent.minimum = null;
		this.buildingFilter.ratingToRentRatioCurrent.maximum = null;
		this.buildingFilter.searchTerm = null;
		this.buildingFilter.submarkets = [];
		this.buildingFilter.districts = [];
		this.buildingFilter.postalCodes = [];

		//Building Options
		this.buildingFilter.buildingTenancies = [{ label: "Office Leased", value: "Office Leased"}];
		this.buildingFilter.buildingStatuses = [];
		this.buildingFilter.competitiveSets = [];
		this.buildingFilter.askingRent.minimum = null;
		this.buildingFilter.askingRent.maximum = null;
		this.buildingFilter.percentLeased = [0, 100];
		this.buildingFilter.directAvailableSquareFootage.minimum = null;
		this.buildingFilter.directAvailableSquareFootage.maximum = null;
		this.buildingFilter.subleaseAvailableSquareFootage.minimum = null;
		this.buildingFilter.subleaseAvailableSquareFootage.maximum = null;
		this.buildingFilter.totalVacantSquareFootage.minimum = null;
		this.buildingFilter.totalVacantSquareFootage.maximum = null;
		this.buildingFilter.directVacantSquareFootage.minimum = null;
		this.buildingFilter.directVacantSquareFootage.maximum = null;
		this.buildingFilter.subleaseVacantSquareFootage.minimum = null;
		this.buildingFilter.subleaseVacantSquareFootage.maximum = null;
		this.buildingFilter.maxContiguousSquareFootage.minimum = null;
		this.buildingFilter.maxContiguousSquareFootage.maximum = null;
		this.buildingFilter.minimumAvailableSquareFootage.minimum = null;
		this.buildingFilter.minimumAvailableSquareFootage.maximum = null;
		this.buildingFilter.occupiedSquareFootage.minimum = null;
		this.buildingFilter.occupiedSquareFootage.maximum = null;
		this.buildingFilter.availableSquareFootage = [0, this.maxValueSF];
		this.buildingFilter.subclasses = [];
		this.buildingFilter.propertyTypes = [];
		this.buildingFilter.buildingRenovations = [];
		this.buildingFilter.yearOfRenovation.minimum = null;
		this.buildingFilter.yearOfRenovation.maximum = null;
		this.buildingFilter.mixedUses = [];
		this.buildingFilter.singleTenants = [];
		this.buildingFilter.parking = [];
		this.buildingFilter.numberOfFloors.minimum = null;
		this.buildingFilter.numberOfFloors.maximum = null;
		this.buildingFilter.propertySize.minimum = null;
		this.buildingFilter.propertySize.maximum = null;
		this.buildingFilter.parkingRatio.minimum = null;
		this.buildingFilter.parkingRatio.maximum = null;
		this.buildingFilter.walkScore = [0, 100];
		this.buildingFilter.proximityToLightRail.minimum = null;
		this.buildingFilter.proximityToLightRail.maximum = null;

		this.listRatingFiltersComponent.clearRatingFilters();

		this.BuildingTenancy();
		this.BuildingStatus();

		this.BuildingSquareFootageMinMaxValue();
		this.onBuildinFilterChange(event,true);

		if (eventData == 'true') {
			this.onBuildinFilterChange(event,true);
		}

		this.route.navigate([],{
			queryParams: {
				'propertyId':null,
			},
			queryParamsHandling:'merge'
		})
	}

	DefaultDateSelected() {
		//this.FromDateString = "YEAR#" + this.fromDate.getFullYear() + "@@MONTH#" + this.fromDate.getMonth() + "@@DAY#" + this.fromDate.getDate();
		//this.ToDateString = "YEAR#" + this.endDate.getFullYear() + "@@MONTH#" + this.endDate.getMonth() + "@@DAY#" + this.endDate.getDate();
		if (this.defultDateSelected) {
			this.defultDateSelected = false;
			this.myFormTodate = this.formBuilder.group({
				myToDate: ""
			});
			this.endDate = null;
			this.ToDateString = null;
			this.marketService.myToDate = null;
		}
		else {
			if (this.setDateOnSelectPicker && this.endDate == null) {
				this.endDate = new Date();
				this.myFormTodate = this.formBuilder.group({
					myToDate: [{ date: { year: this.endDate.getFullYear(), month: this.endDate.getMonth() + 1, day: this.endDate.getDate() } }, Validators.required]
				});
			}
			this.setDateOnSelectPicker = false;
		}

	}

	mapClicked($event: MouseEvent) {
		draggable: false
	}

	markerDragEnd(m: location, $event: MouseEvent) {
		//console.log('dragEnd', m, $event);
	}

	clickedMarker(propertyId, index: number) {
		this.carouselImageIndex = 0;
		//console.log(`clicked the marker: ${index}` + index + propertyId);
		this.marketService.GetMarkersDetailsByPropertyId(propertyId).subscribe(
			(res: any) => {
				this.officeMarketBuildingListByPropertyId = res;
			}
		);
	}

	mouseOver(infoWindow, $event: MouseEvent, name, iconURL) {
		// console.log("HI IM HERE");
		// console.log(iconURL);
		if(document.getElementById("mapContentBox") == null){
			// infoWindow._openInfoWindow();
			infoWindow.open();
		}
	}

	mouseOut(infoWindow, $event: MouseEvent, name) {
		// console.log("HI IM HERE AGAIN");
		// infoWindow._closeInfoWindow();
		infoWindow.close();
	}

	getCurrentPreviousQuarter(value) {
		var today = new Date(),
			quarter = Math.floor((today.getMonth() / 3)),
			startDate,
			endDate;

		switch (value) {
			case "previous":
				startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
			default:
				startDate = new Date(today.getFullYear(), quarter * 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
		}

		return {
			StartDate: startDate,
			EndDate: endDate
		};
	}

	geocode(address: string): Promise<any> {
		const geocoder = new google.maps.Geocoder();
		return new Promise((resolve, reject) => {
			geocoder.geocode(
				{
					address: address
				},
				(results, status) => {
					if (status === google.maps.GeocoderStatus.OK) {
						resolve(results[0]);
					} else {
						reject(new Error(status));
					}
				}
			);
		});
	}

	async BuildingSquareFootageMinMaxValue() {
		//Api calling for SubMarketList
		await this.marketService.BuildingSquareFootageMinMaxValue().toPromise().then(
			(res: any) => {
				this.minValueSF = JSON.parse(res["minSFValue"]);
				this.maxValueSF = JSON.parse(res["maxSFValue"]);
				this.buildingFilter.availableSquareFootage = [0, this.maxValueSF];
			},
			err => {

			}
		);
	}

	SubMarket() {
		//Api calling for SubMarketList
		this.marketService.SubMarketList().subscribe(
			(res: any) => {
				this.submarketOptions = res;
			},
			err => {

			}
		);
	}
	District() {
		this.marketService.DistrictList().subscribe(
			(res: any) => {
				this.districtOptions = res;
			},
			err => {

			}
		);
	}


	BuildingClass() {
		//Api calling for BuildingClassList
		this.marketService.BuildingClassList().subscribe(
			(res: any) => {
				this.buildingClassOptions = res;
			},
			err => {

			}
		);
	}

	BuildingLeaseType() {
		//Api calling for BuildingLeaseTypeList
		this.marketService.BuildingLeaseTypeList().subscribe(
			(res: any) => {
				this.leaseTypeOptions = res;
			},
			err => {

			}
		);
	}

	BuildingSubclass() {
		//Api calling for BuildingSubclassList
		this.marketService.BuildingSubclassList().subscribe(
			(res: any) => {
				this.subclassOptions = res;
			},
			err => {

			}
		);
	}

	BuildingPropertyType() {
		//Api calling for BuildingPropertyTypeList
		this.marketService.BuildingPropertyTypeList().subscribe(
			(res: any) => {
				this.propertyTypeOptions = res;
			},
			err => {

			}
		);
	}

	BuildingRenovations() {
		//Api calling for BuildingRenovationsList
		this.marketService.BuildingRenovationsList().subscribe(
			(res: any) => {
				this.buildingRenovationOptions = res;
			},
			err => {

			}
		);
	}

	BuildingMixedUse() {
		//Api calling for BuildingMixedUseList
		this.marketService.BuildingMixedUseList().subscribe(
			(res: any) => {
				this.mixedUseOptions = res;
			},
			err => {

			}
		);
	}

	BuildingSingleTenant() {
		//Api calling for BuildingSingleTenantList
		this.marketService.BuildingSingleTenantList().subscribe(
			(res: any) => {
				this.singleTenantOptions = res;
			},
			err => {

			}
		);
	}

	BuildingParking() {
		//Api calling for BuildingParkingList
		this.marketService.BuildingParkingList().subscribe(
			(res: any) => {
				this.parkingOptions = res;
			},
			err => {

			}
		);
	}

	BuildingStatus() {
		//Api calling for BuildingStatusList
		this.marketService.BuildingStatusList().subscribe(
			(res: any) => {
				this.buildingStatusOptions = res;
			},
			err => {

			}
		);
	}

	BuildingTenancy() {
		//Api calling for BuildingTenancyList
		this.marketService.BuildingTenancyList().subscribe(
			(res: any) => {
				this.buildingTenantOptions = res;
			},
			err => {

			}
		);
	}

	CompetitiveSet() {
		//Api calling for competitiveSetOptions
		this.marketService.CompetitiveSetList(sessionStorage.getItem('id')).subscribe(
			(res: any) => {
				this.competitiveSetOptions = res;
			},
			err => {

			}
		);
	}

	caluculateTotleSQFT() {
		for (let i: number = 0; i < this.marketService.officeMarketBuildingList.length; i++) {

			if (i <= 13) {
				this.totalSQFt += this.marketService.officeMarketBuildingList[i].buildingNRA;
				this.totalVancentSQFt += this.marketService.officeMarketBuildingList[i].dVacantSF;
			}
		}
		this.percentvacant = (Number(this.totalVancentSQFt) / Number(this.totalSQFt)) * 100;
	}

	onDateChanged(event, dateType) {

		if (dateType == 'from') {

			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0)
			{
				this.fromDate = null;
				this.FromDateString = "";
			}
			else {
				let fromdate = event.formatted;
				this.FromDateString = fromdate;//this.datePipe.transform(new Date(event.date.year, event.date.month - 1, event.date.day ), 'MM/dd/yyyy');//"YEAR#" + event.date.year + "@@MONTH#" + (event.date.month ) + "@@DAY#" + (event.date.day);
				this.fromDate = new Date(event.date.year, event.date.month - 1, event.date.day + 1);

			}
		}
		else {
			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0) {
				this.endDate = null;
				this.ToDateString = "";
			}
			else {
				let todate = event.formatted;
				this.endDate = new Date(event.date.year, event.date.month - 1, event.date.day + 1);
				this.ToDateString = todate;//this.datePipe.transform(this.endDate, 'MM/dd/yyyy');//"YEAR#" + event.date.year + "@@MONTH#" + (event.date.month) + "@@DAY#" + (event.date.day);


			}
		}
		//this.FromDateString = "YEAR#" + event.date.year + "@@MONTH#" + (event.date.month- 1) + "@@DAY#" + event.date.day + 1;
		//this.ToDateString = "YEAR#" + this.endDate.getFullYear() + "@@MONTH#" + this.endDate.getMonth() + 1 + "@@DAY#" + this.endDate.getDate();

		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;
	}
	onBuildinFilterChange(event,actually=false) {

		if(!actually) {
			return;
		}

		let query = this.route.parseUrl(this.route.url).queryParams;
		if(!(query && Object.keys(query).length > 0)) {
			this.location.go('/marketBuilding');
		}


		if (event != null) {
			this.setDateOnSelectPicker = true;
		}

		this.MapLoader = true;
		this.propertyId = '';
		this.contiguousSFMin = this.buildingFilter.maxContiguousSquareFootage.minimum;

		//Stored data into sevice property to use further implemenation
		this.marketService.inputFilterSearchTerm = this.buildingFilter.searchTerm;
		this.marketService.subMarket = this.buildingFilter.submarkets.map(function(x){return x.value;}).join(",");
		this.marketService.district = this.buildingFilter.districts.map(function(x){return x.value;}).join(",");
		this.marketService.class = this.buildingFilter.buildingClasses.map(function(x){return x.value;}).join(",");
		this.marketService.tenancy = this.buildingFilter.buildingTenancies.map(function(x){return x.value;}).join(",");
		this.marketService.status = this.buildingFilter.buildingStatuses.map(function(x){return x.value;}).join(",");
		this.marketService.leaseType = this.buildingFilter.leaseTypes.map(function(x){return x.value;}).join(",");

		this.marketService.rangeSFValuesMin = this.buildingFilter.availableSquareFootage[0];
		this.marketService.rangeSFValuesMax = this.buildingFilter.availableSquareFootage[1];

		this.marketService.rangePercentLeasedValuesMin = this.buildingFilter.percentLeased[0];
		this.marketService.rangePercentLeasedValuesMax = this.buildingFilter.percentLeased[1];

		this.marketService.rangeNumberOfFloorMinValues = this.buildingFilter.numberOfFloors.minimum;
		this.marketService.rangeNumberOfFloorMaxValues = this.buildingFilter.numberOfFloors.maximum;

		this.marketService.rangePropertySizeMin = this.buildingFilter.propertySize.minimum;
		this.marketService.rangePropertySizeMax = this.buildingFilter.propertySize.maximum;

		this.marketService.inputparkingRatioMinValue = this.buildingFilter.parkingRatio.minimum;
		this.marketService.inputparkingRatioMaxValue = this.buildingFilter.parkingRatio.maximum;

		this.marketService.rangeWalkScoreValuesMin = this.buildingFilter.walkScore[0];
		this.marketService.rangeWalkScoreValuesMax = this.buildingFilter.walkScore[1];

		this.marketService.inputMinValueAskingRent = this.buildingFilter.askingRent.minimum;
		this.marketService.inputMaxValueAskingRent = this.buildingFilter.askingRent.maximum;

		this.marketService.inputLightRailMinValue = this.buildingFilter.proximityToLightRail.minimum;
		this.marketService.inputLightRailMaxValue = this.buildingFilter.proximityToLightRail.maximum;

		this.marketService.inputavailableSFDirectMinValue = this.buildingFilter.directAvailableSquareFootage.minimum;
		this.marketService.inputavailableSFDirectMaxValue = this.buildingFilter.directAvailableSquareFootage.maximum;

		this.marketService.inputavailableSFSLMinValue = this.buildingFilter.subleaseAvailableSquareFootage.minimum;
		this.marketService.inputavailableSFSLMaxValue = this.buildingFilter.subleaseAvailableSquareFootage.maximum;

		this.marketService.inputttlVacantSFMinValue = this.buildingFilter.totalVacantSquareFootage.minimum;
		this.marketService.inputttlVacantSFMaxValue = this.buildingFilter.totalVacantSquareFootage.maximum;

		this.marketService.inputdVacantSFMinValue = this.buildingFilter.directVacantSquareFootage.minimum;
		this.marketService.inputdVacantSFMaxValue = this.buildingFilter.directVacantSquareFootage.maximum;

		this.marketService.inputslVacantSFMinValue = this.buildingFilter.subleaseVacantSquareFootage.minimum;
		this.marketService.inputslVacantSFMaxValue = this.buildingFilter.subleaseVacantSquareFootage.maximum;

		this.marketService.inputcontiguousSFMinValue = this.buildingFilter.maxContiguousSquareFootage.minimum;
		this.marketService.inputcontiguousSFMaxValue = this.buildingFilter.maxContiguousSquareFootage.maximum;

		this.marketService.inputminAvailableSFMinValue = this.buildingFilter.minimumAvailableSquareFootage.minimum;
		this.marketService.inputminAvailableSFMaxValue = this.buildingFilter.minimumAvailableSquareFootage.maximum;

		this.marketService.inputoccupiedSFMinValue = this.buildingFilter.occupiedSquareFootage.minimum;
		this.marketService.inputoccupiedSFMaxValue = this.buildingFilter.occupiedSquareFootage.maximum;

		this.marketService.inputRatingToRentRatioMinValue = this.buildingFilter.ratingToRentRatioCurrent.minimum;
		this.marketService.inputRatingToRentRatioMaxValue = this.buildingFilter.ratingToRentRatioCurrent.maximum;

		this.marketService.subclass = this.buildingFilter.subclasses.map(function(x){return x.value;}).join(",");

		this.marketService.propertyType = this.buildingFilter.propertyTypes.map(function(x){return x.value;}).join(",");
		
		this.marketService.renovations = this.buildingFilter.buildingRenovations.map(function(x){return x.value;}).join(",");

		this.marketService.inputyearOfRenovationMinValue = this.buildingFilter.yearOfRenovation.minimum;
		this.marketService.inputyearOfRenovationMaxValue = this.buildingFilter.yearOfRenovation.maximum;

		this.marketService.mixedUse = this.buildingFilter.mixedUses.map(function(x){return x.value;}).join(",");

		this.marketService.singleTenant = this.buildingFilter.singleTenants.map(function(x){return x.value;}).join(",");

		this.marketService.parking = this.buildingFilter.parking.map(function(x){return x.value;}).join(",");

		this.marketService.competitiveSet = this.buildingFilter.competitiveSets.map(function(x){return x.value;}).join(",");

		this.marketService.propertyId = "0";

		this.marketService.officeMarketBuildingDeletedList = [];

		this.marketService.MarkersDetailbyFilter().subscribe(
			async (res: any) => {

				let query = this.route.parseUrl(this.route.url).queryParams;

				if(query && Object.keys(query).length > 0) {
					console.log(`doing filter based on ${JSON.stringify(query)}`);
					res = res.filter(e=>{
						let match = true;
						for(let p in query){
							if(e[p] != query[p]) {
								match = false;
								break;
							}
						}
						return match;
					})
				}				

				this.listRatingFiltersComponent.filterBuildings(res).subscribe(filteredBuildings => {
					this.marketService.officeMarketBuildingList = filteredBuildings;
					this.pushInMarker();
					this.UpdateStatsPanel();
					this.markers = this.marketService.officeMarketBuildingList;

					if(this.myMap) {
						console.log('Resizing map bounds ...');
						setTimeout(()=>{
							const bounds: LatLngBounds = new google.maps.LatLngBounds();
							for (const mm of this.markers) {
								bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
							}
							this.myMap.fitBounds(bounds)}
						,0);
					}
				});				

			},
			err => {
				this.MapLoader = false;
			}
		);
	}

	//Event click on box on right side of map 07102019
	pushInMarkerSingle(obj): void {

		if (this.isPageFirstTime == true) {
			this.isMarkerSingle = true;
			this.Buildingobj = Object.create(obj);
			this.markers = [obj.location];

			this.marketService.officeMarketBuildingList = [obj];

			// console.log("Single click" + this.officeMarketBuildingListCopy);
			this.pushInMarker();
			this.propertyId = obj["propertyId"]
			this.UpdateStatsPanel();
			this.rightSectionColor = { 'background': '#b9c7d0' };
			this.isPageFirstTime = false;
			this.isMarkerSingle = false;
			this.marketService.propertyId = obj["propertyId"];
		}
		else {
			this.propertyId = '';
			this.marketService.propertyId = "0";
			this.onBuildinFilterChange(event,true);
			this.rightSectionColor = { 'background': '#ffffff' };
			this.isPageFirstTime = true;
		}
	};

	//Calculate value for building 05102019
	pushInMarker() {
		//pointer coloring base on building 11102019
		let listchange: any[];
		if (this.isMarkerSingle) {
			listchange = this.marketService.officeMarketBuildingList;
		}
		else {
			listchange = this.marketService.officeMarketBuildingList;
		}

		listchange.forEach((Buildingobj, index) => {

			Buildingobj["iconUrl"] = this.IconUrl + Buildingobj.submarketCode;
		});
		this.caluculateTotleSQFT()
		var that = this;
		this.MapLoader = false;
		//this.loader = false;

		this.UpdateStatsPanel();
	};

	//Remove building from right side map 05102019
	DeleteFromArray(index, id, propertyIdToRemove) {
		this.propertyId = propertyIdToRemove;

		//Remove element from main list, store in separate to readd
		const propertyToRemove = this.marketService.officeMarketBuildingList.find(s => s.propertyId == propertyIdToRemove)
		this.marketService.officeMarketBuildingDeletedList.push(propertyToRemove);

		this.marketService.officeMarketBuildingList = this.marketService.officeMarketBuildingList.filter(function( obj ) {
			return obj.propertyId !== propertyIdToRemove;
		});

		this.UpdateStatsPanel();
	}

	QuarterAndQuarterYear() {
		//Api calling for quarterAndQuarterYearList
		this.marketService.GetAbsorptionQuarters().subscribe(
			(res: any) => {
				this.quarterAndQuarterYearList = res;
			},
			err => {
			});
	}

	CalculateAbsorption() {

		if (this.selectedFromQuarterstr1 === undefined || this.selectedFromQuarterstr2 === undefined) {
			return;
		}

		this.MapLoader = true;

		this.marketService.CalculateAbsorption(
			this.selectedFromQuarterstr1,
			this.selectedFromQuarterstr2,
		).subscribe(
				(res: any) => {
					if (res == null) {
						this.absorptionForOccupiedSF = 0;
						this.MapLoader = false;
					}
					else {
						this.absorptionForOccupiedSF = res;
						this.MapLoader = false;
					}
				},
				err => {
					this.MapLoader = false;
				}
			);
	}

	ShowAllBuildingRecord() {
		this.marketService.officeMarketBuildingDeletedList.forEach(element => {
			this.marketService.officeMarketBuildingList.push(element);
		});

		this.marketService.officeMarketBuildingDeletedList = [];

		this.UpdateStatsPanel();
	}

	UpdateStatsPanel() {
		//Total Sq.Ft. && Total Vacant
		let Rsf = 0;
		let Sf = 0;

		this.marketService.officeMarketBuildingList.filter(function (location) {
			Rsf = Number(Rsf) + Number(location["buildingNRA"]);
			Sf = Number(Sf) + Number(location["ttlVacantSF"]);
		});

		this.Buildingobj.Rsf = Rsf;
		this.Buildingobj.Sf = Sf;

		//Vacant %
		this.totalVacantPercentage = (Number(this.Buildingobj.Sf) / Number(this.Buildingobj.Rsf)) * 100;

		//AVG Rating && AVG Rating to Rent && AVG Vacancy Rating && AVG Vacancy Rating to Rent
		this.scoreService.CalculateStats(this.marketService.officeMarketBuildingList, this.marketService.scoreWeight.id);

		//Absorption
		this.CalculateAbsorption();
	}

	ReloadResultSetData() {
		this.propertyId = '';
		this.marketService.officeMarketBuildingDeletedList = [];
		this.onBuildinFilterChange(event,true);
	}

	onPage(event){		
		this.carouselImageIndex = event.page;
	}

	onFileSelect(event) {
		if (event.target.files.length > 0) {
			const file = event.target.files[0];
			this.uploadForm.get('image').setValue(file);
		}
	}
	onSubmit() {		
		this.MapLoader = true;
		const formData = new FormData();
		this.uploadForm.get('propertyId').setValue(this.officeMarketBuildingListByPropertyId[0].propertyId);

		if (this.uploadForm.value.image == "" || this.uploadForm.get('image').value == "" || this.uploadForm.get('image').value == null) {
			this.MapLoader = false;
			alert("Select file.");
			return;
		}
		
		if (this.uploadForm.invalid) {
			this.MapLoader = false;
			alert("Enter the details.");
			return;
		}		
		else if (this.uploadForm.get('image').value != "") {
			if (this.uploadForm.get('image').value == "nofile") {
				this.uploadForm.get('image').value == "";
			}

			formData.append('image', this.uploadForm.get('image').value);
			formData.append('propertyId', this.officeMarketBuildingListByPropertyId[0].propertyId);						
			
			this.httpClient.post<any>(environment.BaseURI_API_Account + 'UploadPropertyImage', formData).subscribe(
				(res) => {
					this.marketService.GetMarkersDetailsByPropertyId(this.officeMarketBuildingListByPropertyId[0].propertyId).subscribe(
						(res: any) => {
							this.carouselImageIndex = res[0].images.length - 1;							
							this.officeMarketBuildingListByPropertyId = [{...res[0], "imageUpdate": true}];
							alert("File uploaded successfully.");
							this.MapLoader = false;	
							
							this.uploadForm.reset();
						}
					);
				},
				(err) => {
					console.log(err);
					alert("File not uploaded.");					
					this.MapLoader = false;

					this.uploadForm.reset();
				}
			);
		}	
	}
	MakePrimaryImage(id: string) {
		this.marketService.MakePrimaryImage(id).subscribe(
			(res: any) => {				
				this.marketService.GetMarkersDetailsByPropertyId(this.officeMarketBuildingListByPropertyId[0].propertyId).subscribe(
					(res: any) => {
						this.officeMarketBuildingListByPropertyId = [{...res[0], "imageUpdate": true}];
					}
				);
			}
		);
	}
	DeleteImage(id: string) {
		if (confirm("Are you sure you want to delete this image?")) {
			this.marketService.DeleteImage(id).subscribe(
				(res: any) => {				
					this.marketService.GetMarkersDetailsByPropertyId(this.officeMarketBuildingListByPropertyId[0].propertyId).subscribe(
						(res: any) => {
							if(this.carouselImageIndex > 0) {
								this.carouselImageIndex = this.carouselImageIndex - 1;
							}
							this.officeMarketBuildingListByPropertyId = [{...res[0], "imageUpdate": true}];
						}
					);
				}
			);
		}
	}

	GetMapTypeId(mapType) {
		this.marketService.mapTypeIdSelected = mapType;
		//alert(event);
	}
}

// Interface for the Map
interface marker {
	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
	IconUrl: string;
}

interface Absorption {
	id: string,
	quarterYear: string

}
export interface location {
	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
}
export class MyModel {

	val: number = 100;
	rangeValues: number[] = [20, 80];
}
export class Custom {
	id: number
}
